// Pure (dependency-free) plan-section helpers. Kept separate from
// launchReadiness.js so consumers like the launch checklist can use
// them without dragging in the ComplianceScoreCard → apiClient → axios
// import chain (which Jest can't transform).

// Canonical Three Little Birds-generated plan sections used to gauge "Written Plan" completion.
export const CORE_SECTIONS = [
  "executive_summary", "refined_description", "market_analysis",
  "competitive_analysis", "customer_acquisition", "pricing_model",
  "revenue_projection", "infrastructure_personnel",
  "infrastructure_technology", "infrastructure_administration",
];

// Feb 18 2026 — Executive Summary is derived from the questionnaire
// and the BusinessPlan sidebar always marks `section-summary` as
// "generated" the moment a plan exists. Mirror the sidebar's
// convention so the Hub's Plan % agrees with it.
export function sectionDone(business, k) {
  const plan = business?.plan;
  if (!plan) return false;
  const q = business?.questionnaire || {};
  const descriptions =
    (plan.descriptions && typeof plan.descriptions === "object") ? plan.descriptions : {};
  if (k === "executive_summary") {
    const direct = plan[k];
    if (typeof direct === "string" ? direct.trim().length > 0 : !!direct) return true;
    const derived = descriptions.executive_summary;
    if (typeof derived === "string" ? derived.trim().length > 0 : !!derived) return true;
    const refined = plan.refined_description;
    if (typeof refined === "string" ? refined.trim().length > 0 : !!refined) return true;
    const bd = q.business_description;
    if (typeof bd === "string" ? bd.trim().length > 0 : !!bd) return true;
    return Object.keys(plan).length > 0;
  }
  const v = plan[k];
  return typeof v === "string" ? v.trim().length > 0 : !!v;
}

export function hasHealthCheck(business) {
  return typeof business?.health_check?.score === "number";
}

export function hasRoadmap(business) {
  return Array.isArray(business?.roadmap) && business.roadmap.length > 0;
}

export function hasCompliance(business) {
  const items = business?.compliance?.items;
  return Array.isArray(items) && items.length > 0;
}
